import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import CommonServices from "../based/services/CommonServices";

function ShippingBarcodeModal({ show, onClose }) {
    const [shippingServices, setShippingServices] = useState([]); //đơn vị vận chuyển

    useEffect(() => {
        _getShippingServices();
    }, []);

    async function _getShippingServices() {
        let [err, data] = await CommonServices.GetShippingServices();
        if (!err && data && data.length > 0) {
            setShippingServices(data);
        } else {
            setShippingServices([]);
        }
    }

    async function _updateBarcode(shippingServiceId, barcode) {
        let [err, data] = await CommonServices.UpdateBarcode(shippingServiceId, barcode);
        if (!err && data) {
            _getShippingServices();
        }
    }

    return (
        <CommonModal show={show} onClose={onClose} title="Sửa Barcode">
            <Wrapper>
                <div className="list-shipping">
                    {shippingServices &&
                        shippingServices.length > 0 &&
                        shippingServices.map((item, index) => {
                            return (
                                <div className="shipping-item form-group" key={index}>
                                    <label htmlFor="">{item.name}</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Nhập barcode"
                                            value={item.packageBarcode}
                                            onChange={(e) => {
                                                let ss = [...shippingServices];
                                                ss[index].packageBarcode = e.target.value;
                                                setShippingServices(ss);
                                            }}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() => {
                                                    _updateBarcode(item.id, item.packageBarcode);
                                                }}
                                            >
                                                Lưu
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default ShippingBarcodeModal;

const Wrapper = styled.div``;
